// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * cm-coding: Global administrators configure the models available to DocReview
 * on this system operations page. The route supplies the shared administration
 * background and content width, while LLMManagement supplies the heading and
 * controls; adding a second page header would present one model configuration
 * task as two separate sections.
 */
import { LLMManagement } from '@/subsystems/workspaces/components/llm/LLMManagement';

export default function LLMConfigPage() {
  const debugMode = import.meta.env.VITE_WORKSPACES_DEBUG_LOGGING === 'true';

  return (
    <div className="min-h-full bg-slate-50 text-slate-900">
      <div className="mx-auto max-w-[1280px] px-6 pt-9 pb-16 sm:px-10">
        <LLMManagement app_id="docreview" debug={debugMode} />
      </div>
    </div>
  );
}
